import { TopListWidget } from '@DashboardV2/components/TopListWidget/TopListWidget';
import { useResourceTypesUsageStats } from '@DashboardV2/services/gql';
import { AVAILABLE_COLORS } from '@common/constants';
import { useMemo } from 'react';
import { Loader } from '@components';
import { PieChartEmptyState } from '@DashboardV2/components/PieChartEmptyState';
import { WidgetCard } from '@DashboardV2/components/WidgetCard';

export function Top10CloudServices() {
  return (
    <WidgetCard title="Top 10 Requested Cloud Services" subtitle="Last 30 days">
      <Top10ResourceTypes />
    </WidgetCard>
  );
}

function Top10ResourceTypes() {
  const { data, isFetched } = useResourceTypesUsageStats({ take: 10 });

  const resourceTypeData = useMemo(() => {
    if (!data) return [];
    const totalRequests = data.requestsPerResourceTypeStats.reduce((acc, curr) => acc + curr.totalRequests, 0);

    return data.requestsPerResourceTypeStats
      .filter((request) => request.resourceType && request.totalRequests)
      .map((request, i) => ({
        iconSrc: request.resourceType?.icons.svg,
        text: request.resourceType?.typeDisplayName || '',
        color: AVAILABLE_COLORS[i % AVAILABLE_COLORS.length],
        sum: request.totalRequests,
        percent: Number(((request.totalRequests / totalRequests) * 100).toFixed(2)),
      }));
  }, [data]);

  if (!isFetched) return <Loader />;

  if (resourceTypeData.length === 0)
    return (
      <PieChartEmptyState
        title="No Requests Created for this period"
        subtitle="No access requests match the chosen time period."
        variant="small"
      />
    );

  return <TopListWidget integrationsData={resourceTypeData} />;
}
